var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel3Illustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 794 794",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M686 340H124v359h562V340z",
    fill: "#F0BE8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M600 470H211v33.442h389V470zm-141.514 81.558H211V585h247.486v-33.442z",
    fill: "#F26445"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M651.377 85L101 284.015 134.626 377 685 177.988 651.377 85z",
    fill: "#48B7A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.305 273.084l32.672-11.818-6.992 70.312-32.641 11.849 6.961-70.343zm65.218-23.637l32.64-11.818-6.992 70.312-32.64 11.85 6.992-70.344zm65.186-23.636l32.64-11.85-6.96 70.344-32.672 11.849 6.992-70.343zm65.312-23.668l32.546-11.818-6.992 70.343-32.546 11.787 6.992-70.312zm65.186-23.636l32.546-11.819-6.96 70.344-32.547 11.787 6.961-70.312zm65.218-23.637l32.64-11.85-6.992 70.344-32.64 11.818 6.992-70.312zm65.186-23.636l32.64-11.85-6.96 70.344-32.672 11.818 6.992-70.312zM643.365 107L665 166.971l-30.163 10.938 6.961-70.312 1.567-.597zm-499.73 249L122 296.06l30.195-10.938-6.993 70.312-1.567.566z",
    fill: "#F26445"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel3Illustration);
export default __webpack_public_path__ + "static/media/level-3-illustration.6510f1a04afd95b11175c4e7faebce46.svg";
export { ForwardRef as ReactComponent };